import React from "react";
import ReactDOM from "react-dom";
import ChatBot from "./components/chatbot";

const chatbot = document.getElementById("chatbot");
const chatbot_api_url = chatbot.getAttribute("chatbot-api-url");

ReactDOM.render(
  <ChatBot
    config={{
      chatbot_api_url: chatbot_api_url,
    }}
  />,
  chatbot,
);
